import { LocalDate } from '../../core/model/local-date';
import { ModelBase } from '../../core/model/model-base';
import { Money } from '../../core/model/money';
import { MeterMediaType } from './const/enums';
import { ConsumptionMeterModel } from './consumption-meter-model';

export class MeterReading extends ModelBase {
  constructor(val?: any) {
    super();
    if (val) {
      this.id = val.id;
      this.consumptionDate = LocalDate.fromDate(val.consumptionDate);
      this.consumption = val.consumption;
      this.leaseAgreementNumber = val.leaseAgreementNumber;
      this.rentalId = val.rentalId;
      this.meterName = val.meterName;
      this.meterTypeText = val.meterTypeText;
      this.debitOnLeaseAgreementActive = val.debitOnLeaseAgreementActive;
      this.imdPriceListName = val.ImdPriceListName;
    }
  }

  consumptionDate: LocalDate;
  consumption: number;
  rentalId: string;
  leaseAgreementNumber: string;
  meterName: string;
  meterTypeText: string;
  debitOnLeaseAgreementActive: string;
  imdPriceListName: string;
}

export class ImdImport extends ModelBase {
  constructor(val?: any) {
    super();
    if (val) {
      this.meterReadings = Array.isArray(val.meterReadings) ? val.meterReadings.Map(v => new MeterReading(v)) : [];
      this.importIdentifier = val.importIdentifier;
      this.importedAt = val.importedAt;
      this.recievedAt = val.recievedAt;
    }
  }

  meterReadings: MeterReading[];
  importedAt: Date;
  recievedAt: Date;
  importIdentifier: string;

  toString(culture?: string): string {
    return this.importIdentifier;
  }
}
